"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lambda = void 0;
const services_1 = require("../services");
const lambda = (config) => {
    return (mode, src, { width, height, quality = services_1.DEFAULT_IMG_QUALITY }) => {
        if (!(0, services_1.validateResizeOptions)(mode, { width, height }))
            return src;
        const source = config.sources.find((source) => {
            return src.startsWith(source.source);
        });
        if (!source)
            return src;
        const key = decodeURIComponent(src.replace(`${source.source}/`, "")).replace(/\+/g, " ");
        const params = {
            bucket: source.bucket,
            key,
            edits: {
                resize: {
                    width,
                    height,
                    fit: { crop: "cover", resize: "inside" }[mode],
                },
                webp: { quality },
                jpeg: { quality },
                rotate: null,
            },
        };
        const encoded = Buffer.from(JSON.stringify(params)).toString("base64");
        return `${config.endpoint}/${encoded}`;
    };
};
exports.lambda = lambda;
